import { Value } from 'components/Paginations';

export const fixPagination = (pagination: Value, count: number): Value => {
  const maxPage = Math.ceil(count / pagination.limit) || 1;
  const page = pagination.page < maxPage ? pagination.page : maxPage;
  return { ...pagination, page };
};
